import { Route } from "react-router-dom";
import { pages } from "../../../utils/common";
import HelpView from "./help.view";

const useHelpRoutes = () => {
  return <Route path={pages.help.path} element={<HelpView />} />;
};

export default useHelpRoutes;
